import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-breadcrumb-faq',
  templateUrl: './breadcrumb-faq.component.html',
  styleUrls: ['./breadcrumb-faq.component.css']
})
export class BreadcrumbFaqComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
